import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { DisplayListPagination } from '../../../components/TapUi';

const SimListing = ({ history, location }) => {
    const [minimizeTable, setMinimizeTable] = useState(false);
    const [simDetail, setSimDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [simData, setSimData] = useState([]);
    const [simDetailLoading, setSimDetailLoading] = useState(false);
    const [listingMeta, setListingMeta] = useState(null);
    const access_token = useSelector(state => state.auth.access_token);
    const viewSimDetailData = (id) => {
        if (minimizeTable && simDetail?.id === id) {
            return;
        }
        setMinimizeTable(true);
        setSimDetailLoading(true)
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/sim_detail/' + id, access_token, {}, {}, (resp) => {
            const respData = resp?.data
            setSimDetail(respData);
        }).then(() => setSimDetailLoading(false))
    }

    const closeView = () => {
        setMinimizeTable(false);
        setSimDetail(null);
    }
    const editSimInit = (item) => {
        history.push({ pathname: `/sim_add`, state: { editSimData: item } });
    };

    const getSimListing = (page = 1) => {
        setLoading(true)
        const params = { page: page, per_page: 50, };
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/sim_list', access_token, params, {}, (resp) => {
            const respData = resp.data
            setSimData(respData.data);
            setListingMeta({
                'from': respData.from,
                'to': respData.to,
                'total': respData.total,
                'last_page': respData.last_page,
                'per_page': respData.per_page,
                'current_page': respData.current_page
            });

        }).then(() => setLoading(false));

    }
    useEffect(() => {
        console.log(location);
        getSimListing(1);

        if (location?.state?.id) {
            viewSimDetailData(location.state.id);
        }

    }, []);

    const deleteSimInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {

                HttpAPICall.withAthorization('DELETE', BACKOFFICE_BASE_URL + '/sim_delete/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    setMinimizeTable(false)
                    getSimListing(1);
                }).then(() => { });
            }
        });
    }
    const simListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        {minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "8%" }}>Sim Listing</th>
                            </tr>
                        ) : (
                            <tr>
                                <th className='text-center' style={{ width: "8%" }}>S.No.</th>
                                <th className='text-center ms-3' style={{ width: "23%" }}>Service Provider Name</th>
                                <th className='text-center ms-3' style={{ width: "23%" }}>Network Type</th>
                                <th className='text-center ms-3' style={{ width: "23%" }}>ICCID</th>
                                <th className='text-center ms-3' style={{ width: "23%" }}>MSSIDN </th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {loading
                            ?
                            <tr><td colSpan={5}><Loader /></td></tr>
                            :
                            simData.length > 0
                                ?
                                simData.map((i, k) => {
                                    return (<>
                                        <tr key={k}>
                                            {minimizeTable ? (
                                                <td style={{ width: "25%" }} className='text-start'>
                                                    <a
                                                        href="#"
                                                        className="text-capitalize link-primary"
                                                        onClick={() => viewSimDetailData(i.id)}
                                                    >
                                                        {i.provider_name}
                                                    </a>
                                                </td>
                                            ) : (
                                                <>
                                                    <td className='text-center'>{listingMeta ?
                                                            (listingMeta.current_page - 1) * listingMeta.per_page + k + 1
                                                            : k + 1}</td>
                                                    <td className='text-center'>
                                                        <a href="#" className="text-capitalize link-primary"
                                                            onClick={() => viewSimDetailData(i.id)}>
                                                            {i.provider_name}
                                                        </a>
                                                    </td>
                                                    <td className='text-center'>
                                                        {i.network_type}
                                                    </td>
                                                    <td className='text-center'>
                                                        {i.sim_number}
                                                    </td>
                                                    <td className='text-center'> {i.mobile_number}
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    </>)
                                })
                                :
                                <tr><td colSpan="5" className="text-center">No Records</td></tr>
                        }
                    </tbody>
                </table>
                <DisplayListPagination meta={listingMeta} onPageChange={(e) => getSimListing(e.selected + 1)} />
            </>
        );
    };

    const simJsx = () => {

        return (
            <>
                <div className="page_title row m0">
                    <div className={minimizeTable ? "col-3" : "col-12"}>
                        <h3>Sim Listing</h3>
                        {(!minimizeTable) ? (
                            <div className="text-end mt15">
                                <>
                                    <Link to="/sim_add">
                                        <button type="button" className="btn btn-primary">Add</button>
                                    </Link>
                                </>
                            </div>
                        ) : null}
                    </div>
                    {minimizeTable ? (
                        <div className="col-9 tap_border_left">
                            <div className="text-end mt15">
                                <span className="dropdown">
                                    <button
                                        type="button"
                                        id='actionMenuButton'
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="btn btn-secondary"
                                    >
                                        <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><button className='dropdown-item' onClick={() => editSimInit(simDetail)}>Edit</button></li>
                                        <li><button className='dropdown-item' onClick={() => deleteSimInit(simDetail.id)}>Delete</button></li>
                                    </ul>
                                </span>
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={closeView}
                                >
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')}>
                            {simListingJsx()}
                        </div>
                        {minimizeTable ? (
                            <div className="col-9 pr4 pl4">
                                <div className="bg-white p-2" style={{ height: "100%" }}>
                                    {simDetails()}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    };

    const simDetails = () => {

        return (
            <div className="tab_content_header">
                <div className="tab_content_wrapper">
                    <span className="content_heading">Sim Details</span>
                </div>
                {simDetailLoading ? <Loader /> :
                    (<>
                        {simDetail && <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                            <tbody>
                                <tr>
                                    <td style={{ width: "26%" }}>Network Provider</td>
                                    <th>{simDetail.provider_name}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Network Type</td>
                                    <th>{simDetail.network_type}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>ICCID</td>
                                    <th>{simDetail.sim_number}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>MSSIDN</td>
                                    <th>{simDetail.mobile_number}</th>
                                </tr>
                                  <tr>
                                    <td style={{ width: "26%" }}>Plan</td>
                                    <th>{simDetail.plan}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Notes</td>
                                    <th>{simDetail.notes}</th>
                                </tr>

                            </tbody>
                        </table>}
                    </>)
                }
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Sim Listing</title></Helmet>
            {simJsx()}
        </ApplicationLayout>
    );
};

export default SimListing;
